module.exports = __webpack_public_path__ + "img/calderara_hero_card.d3713148.png";